import { render, staticRenderFns } from "./publicHeader.vue?vue&type=template&id=caf3ee98&"
import script from "./publicHeader.vue?vue&type=script&lang=js&"
export * from "./publicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports